import { useQuery } from '@tanstack/react-query';
import { Icon, Skeleton } from '@nike/eds';
import { getAdminUserProfile } from '../clientAPI';
import { QUERY_KEYS } from '../constants/index';
import Avatar, { genConfig } from 'react-nice-avatar';
import { useRevalidator } from 'react-router-dom';
import { clearUserToken } from '../utils/authHelpers';

export default function AdminUserAvatar() {
  const revalidator = useRevalidator();
  const { status, data } = useQuery({
    queryKey: [QUERY_KEYS.ADMIN_USER],
    queryFn: async () => getAdminUserProfile(),
    staleTime: Infinity,
    onError: (error) => {
      const err = error as { status: number };
      if (err.status === 401) {
        clearUserToken();
        revalidator.revalidate();
      }
    },
  });

  if (status === 'loading') {
    return (
      <div className='tw-flex tw-items-center'>
        <Skeleton radius='rounded' height={32} width={32} />
        <Skeleton className='tw-ml-2' height={16} width={60} />
      </div>
    );
  }
  if (status === 'success') {
    const config = genConfig(data.username);
    return (
      <div className='tw-flex tw-items-center'>
        <Avatar className='tw-w-8 tw-h-8' {...config} />
        <span className='tw-ml-2'>{data.firstname}</span>
      </div>
    );
  }

  return (
    <Icon
      name='Alert'
      size='m'
      backgroundShape='circle'
      backgroundColor='var(--eds-color-grey-2)'
      enableFocus
    />
  );
}
